export function formatToThreeSignificant(number = 0) {
  return number.toLocaleString();
}
